import type React from "react"
import type { ASPServiceForm as ASPServiceFormType } from "../client"

interface ASPServiceFormDisplayProps {
  serviceForm: ASPServiceFormType
}

const ASPServiceFormDisplay: React.FC<ASPServiceFormDisplayProps> = ({
  serviceForm,
}) => {
  return (
    <>
      <ul>
        <li>Domains: {serviceForm.domains}</li>
      </ul>
    </>
  )
}

export default ASPServiceFormDisplay
